import { SubscriptionDisplayName } from './../typings/plans'
import { SubscriptionName } from '@standardnotes/common'
import { FreeSubscriptionPlanName } from '../typings/plans'

export const planToSubscriptionNameMap = new Map([
  [FreeSubscriptionPlanName, SubscriptionDisplayName.CORE_PLAN],
  [SubscriptionName.PlusPlan, SubscriptionDisplayName.PLUS_PLAN],
  [SubscriptionName.ProPlan, SubscriptionDisplayName.PRO_PLAN],
])
